import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import moment from 'moment';
import EditPayStructureForm from './EditPayslipStructure';
import { getRequest, postRequest } from '../../utils/APICall';
import { useSelector } from 'react-redux';

const UpdatePayStructureForm = ({ visible, onCancel, onOk, editingData }) => {
  const [strucData, setStrucData] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const { users } = useSelector((state) => state.user || {})

// console.log("editingData",editingData)
  const getStructureById = async () => {
    if (editingData?.SALARYSTRUCT_ID) {
      try {
        const res = await getRequest(`getStructure/${editingData.SALARYSTRUCT_ID}`);
        setStrucData(res?.data);
      } catch (error) {
        message.error('Failed to fetch salary structure data');
      }
    }
  };

  useEffect(() => {
    if (visible && editingData && editingData.SALARYSTRUCT_ID) {
      getStructureById();
    }
  }, [visible, editingData]);

  useEffect(() => {
    if (strucData && Array.isArray(strucData) && strucData.length > 0) {
      setEditModalVisible(true);
    }
  }, [strucData]);

  const handleEditFormSubmit = async (data) => {
    // console.log("before Submit Data",data)
    const { employeeId, year, entries } = data;
    const filteredEntries = entries.filter((entry) => entry.isEdited || entry.isNew);

    if (!employeeId || !year || filteredEntries.length === 0) {
      message.error('Please fill all required fields or make changes.');
      return;
    }

    const payload = {
      salarystruct_id: editingData?.SALARYSTRUCT_ID || '0',
      vempName: String(employeeId),
      issuedDate: moment(year, 'DD MMMM YYYY').toDate(),
      entries: filteredEntries.map((entry) => ({
        vtype: entry.type,
        vearning: entry.earning,
      })),
      vcreatedBy: editingData?.CREATEDBY || `${users?.FIRSTNAME} ${users?.LASTNAME} | ${moment(Date.now()).format('DD-MM-YYYY HH:mm')}`,
      veditBy: `${users?.FIRSTNAME} ${moment(Date.now()).format('DD-MM-YYYY HH:mm')}`,
    };

    const hasDuplicate = entries.some(
      (entry, index) => entries.findIndex((e) => e.type === entry.type) !== index
    );
    if (hasDuplicate) {
      message.error('Duplicate salary head types are not allowed.');
      return;
    }
    // console.log(payload)
    try {
      const res = await postRequest('addSalaryStructure', payload);
      if (res?.message) {
        message.success(res.message);
        setEditModalVisible(false);
        onOk();
        window.location.reload();
      } else {
        throw new Error(res.error || 'Something went wrong');
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <>
      {editModalVisible && (
        <EditPayStructureForm
          visible={editModalVisible}
          onCancel={() => {
            setEditModalVisible(false);
            onCancel();
          }}
          onOk={() => {
            setEditModalVisible(false);
            onOk();
          }}
          initialEmployeeId={strucData[0]?.EMP_ID || editingData?.EMP_ID}
          initialEmployeeName={strucData[0]?.FIRSTNAME || editingData?.FIRSTNAME}
          initialYear={strucData[0]?.ISSUE_DATE ? moment(strucData[0].ISSUE_DATE).format('DD MMMM YYYY') : ''}
          initialEntries={strucData.map((item) => ({
            type: item.SALARYHEADS_ID,
            earning: item.SALARYHEADS_AMOUNT,
            isEdited: false,
            isNew: false,
          }))}
          onSubmit={handleEditFormSubmit}
        />
      )}
    </>
  );
};

export default UpdatePayStructureForm;